import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DataStateChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { GridViewManager } from 'src/app/core/model/grid-view-manager';

@Component({
  standalone: false,
  selector: 'app-accumulator-grid',
  templateUrl: './accumulator-grid.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .defaultAlign .accumulatorUnitColumn { text-align: right; }
    .defaultAlign .accumulatorUnitColumn { text-align: right; }
    .defaultAlign .accumulatorAmountColumn { text-align: right; }
    .defaultAlign .accumulatorAmountColumn { text-align: right; }
    .defaultAlign .remainingUnitColumn { text-align: right; }
    .defaultAlign .remainingUnitColumn { text-align: right; }
    .defaultAlign .remainingAmountColumn { text-align: right; }
    .defaultAlign .remainingAmountColumn { text-align: right; }
    .defaultAlign .accumulatorDurationColumn { text-align: right; }
    .defaultAlign .accumulatorDurationColumn { text-align: right; }
    .okUnits .accumulatorUnitColumn { background-color: #7d9550; font-weight: 600; }
    .overUnits .accumulatorUnitColumn { background-color: #e96b62; font-weight: 600; }
    .okAmount .accumulatorAmountColumn { background-color: #7d9550; font-weight: 600; }
    .overAmount .accumulatorAmountColumn { background-color: #e96b62; font-weight: 600; }
    .okUnitsRemaining .remainingUnitColumn { background-color: #7d9550; font-weight: 600; }
    .overUnitsRemaining .remainingUnitColumn { background-color: #e96b62; font-weight: 600; }
    .okAmountRemaining .remainingAmountColumn { background-color: #7d9550; font-weight: 600; }
    .overAmountRemaining .remainingAmountColumn { background-color: #e96b62; font-weight: 600; }
    .okDuration .accumulatorDurationColumn { background-color: #7d9550; font-weight: 600; }
    .overDuration .accumulatorDurationColumn { background-color: #e96b62; font-weight: 600; }
     `
  ]
})
export class AccumulatorGridComponent 
{
  @Input() public gridMaxHeight = '600px';
  @Input() public newTitleKey = 'NEW-TOTAL';
  @Input() public durationLoaded = false;

  public viewAccumulators: GridViewManager = null;
  public gridLoaded = false;

  @Input() public set dataView(view: GridViewManager)
  {
    this.viewAccumulators = view;
    this.gridLoaded = true;
  }

  /**
   * Data change event handler.
   *
   * @param state State of grid operations
   */
  public accumulatorDataStateChange(state: DataStateChangeEvent): void
  {
    this.viewAccumulators.setState(state);
  }

  public accumulatorRowCallback = (context: RowClassArgs) =>
  {
    const cssValue: any = { defaultAlign: true };
    if (context.dataItem.maxUnits != null) 
    {
      cssValue.okUnits = context.dataItem.totalUnits <= context.dataItem.maxUnits;
      cssValue.overUnits = context.dataItem.totalUnits > context.dataItem.maxUnits;
    }
    if (context.dataItem.maxAmount != null)
    {
      cssValue.okAmount = context.dataItem.totalAmount <= context.dataItem.maxAmount;
      cssValue.overAmount = context.dataItem.totalAmount > context.dataItem.maxAmount;
    }
    if (context.dataItem.remainingUnits != null) 
    {
      cssValue.okUnitsRemaining = context.dataItem.remainingUnits >= 0;
      cssValue.overUnitsRemaining = context.dataItem.remainingUnits < 0;
    }
    if (context.dataItem.remainingAmount != null)
    {
      cssValue.okAmountRemaining = context.dataItem.remainingAmount >= 0;
      cssValue.overAmountRemaining = context.dataItem.remainingAmount < 0;
    }
    cssValue.okDuration = !context.dataItem.durationExceeded;
    cssValue.overDuration = context.dataItem.durationExceeded;;
    return cssValue;
  };
}
